import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function NewsNavDetailsPromotion(props) {
    const {news} = props;
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {label: getLocaleContent(locale, 'page.promotion-page.page-title'), href: '/uu-dai'},
                    {label: news?.news_title || getLocaleContent(locale, 'page.promotion-page.promotion-detail')},
                ]}
            />
        </div>
    );
}

export default NewsNavDetailsPromotion;
